angular.module('moebiusProadapt').controller('ctrlEtudeDefIndex',
    ['$rootScope', '$scope', '$http', 'growl', '$timeout', '$window', '$location', '$controller', 'mbsEtiService', 'mbsParticipantService', '$uibModal', 'etude_def_builder_configuration', 'etiAllDynamicDropdown', 'fakeDetailParticipantResolver', 'allQuestionnaireTemplate', 'allQuestionMereTemplate','$sce',
        function ($rootScope, $scope, $http, growl, $timeout, $window, $location, $controller, mbsEtiService, mbsParticipantService, $uibModal, etude_def_builder_configuration, etiAllDynamicDropdown, fakeDetailParticipantResolver, allQuestionnaireTemplate, allQuestionMereTemplate, $sce) {

        $scope.buildMode                 = 'preview';
        $scope.isQrOrigineCollasped      = true;
        $scope.allQuestionnaireTemplate  = allQuestionnaireTemplate;
        $scope.allQuestionMereTemplate   = allQuestionMereTemplate;

        $scope.etude_def_builder_configuration  = etude_def_builder_configuration;
        $scope.onglet  = null;
        $scope.interface = {
            ongletsCount: null,
            questionnaireKey: null,
            QVtoMove: {},
            QVorderedList: []
        };

        $scope.setBuildMode = function(buildMode) {
            // forceReDrawOnglet
            var keepOngletId;
            var keepVisiteKey;
            if ($scope.onglet) {
                keepOngletId  = $scope.onglet.id;
                keepVisiteKey = $rootScope.visite.key;
            }
            $timeout(function() {
                $scope.onglet       = null;
                $scope.buildMode    = buildMode;
            });
            $timeout(function() {
                $scope.selectDetailVisite(keepVisiteKey);
                $scope.selectOnglet(keepOngletId);
            });
        }



        $scope.updateCurrentParticipantsWithCurrentQuestionsVisites = function() {
            var resource = 'etude-def/update-current-etude-publication/etude-def/' + $rootScope.eti.etude_def.key;
            var data = {};
            // var resource = 'visite-def?'+ 'etude_def_key' +'='+$rootScope.eti.etude_def.key;
            var promise = $http.get(resource, data);

            promise.then(
                function(r) {
                    growl.success(JSON.stringify(r.data), { ttl: -1 });
                },
                function(response) {
                    growl.error("Erreur lors de la mise à à jour des participants existants avec les QuestionsVisites");
                }
            );
        }

        $scope.selectDetailVisite = function(visiteKey) {
            mbsEtiService.setCurrentVisite($rootScope.eti.etudedefArray.visitesList[visiteKey]);
            if($rootScope.visite !== null) {
                $scope.onglet                 = $rootScope.eti.etudedefArray.ongletsList[$rootScope.visite.ongletsOrderedIds[0]];
                $scope.interface.ongletsCount = $rootScope.visite.ongletsOrderedIds.length;
            }
        };

        $scope.selectOnglet = function(ongletId) {
            $scope.onglet = $rootScope.eti.etudedefArray.ongletsList[ongletId];
        };


        $scope.addVisite = function() {

            var scopeNew = $scope.$new();
            scopeNew.autoOpenModal = false;
            var settingsCtrlScope = scopeNew;

            // loading resource
            var resource = 'visite-def?'+ 'etude_def_key' +'='+$rootScope.eti.etude_def.key;
            var promise = $http.get(resource).then(function(r){

                var resourceSetting = r.data;
                var allowedFields   = ['key_cross_etude','etude_def_key','name'];
                resourceSetting.form.elements = _.filter(resourceSetting.form.elements, function (element) {
                    if (allowedFields.indexOf(element.name) > -1) {
                        return true;
                    }
                    return false;
                });

                var ctrSetting = $controller('ctrlSettings', {
                    $scope: settingsCtrlScope,
                    // resolve: {
                    list: resourceSetting,
                    resource: 'visite-def',
                    mainFk: {etude_def_key: $rootScope.eti.etude_def.key}
                });
                settingsCtrlScope.openEditModal().then(function() {

                    $scope.refreshEtudeDefConf().then(function() {
                        mbsEtiService.setCurrentEti(-1);
                        $scope.doMapDataEtiConfiguration();
                    })

                })
            });

        };

        $scope.addOnglet = function(visite) {

            var scopeNew = $scope.$new();
            scopeNew.autoOpenModal = false;
            var settingsCtrlScope = scopeNew;

            // loading resource
            var resource = 'onglet-def?'+ 'visite_key' +'='+visite.key;
            var promise = $http.get(resource).then(function(r){

                var resourceSetting = r.data;
                var allowedFields   = ['visite_key','order','name'];
                resourceSetting.form.elements = _.filter(resourceSetting.form.elements, function (element) {
                    if (allowedFields.indexOf(element.name) > -1) {
                        return true;
                    }
                    return false;
                });

                var ctrSetting = $controller('ctrlSettings', {
                    $scope: settingsCtrlScope,
                    // resolve: {
                    list: resourceSetting,
                    resource: 'onglet-def',
                    mainFk: {visite_key: visite.key}
                });
                settingsCtrlScope.openEditModal().then(function() {

                    $scope.refreshEtudeDefConf().then(function() {
                        mbsEtiService.setCurrentEti(-1);
                        $scope.doMapDataEtiConfiguration();
                        mbsEtiService.setCurrentVisite(visite);
                    })

                })
            });

        };

        $scope.trimer = function(expression) {
            if(typeof expression === "undefined") {
                return expression ;
            } else {
                let cleanedExpression = expression.trim() ;
                cleanedExpression = cleanedExpression.replace(/[ _-]/gi, '');
                return cleanedExpression;
            }
        };

        $scope.prepareMoving = function(item, position) {
            $scope.interface.QVtoMove.id = item.id;
            $scope.interface.QVtoMove.key = item.label;
            $scope.interface.QVtoMove.position = position;
        };

        $scope.movethisQVto = function(QVoldOrderedList) {

            let indexElementToMove = _.findIndex(QVoldOrderedList, {id: $scope.interface.QVtoMove.id});
            let elementToMove = QVoldOrderedList[indexElementToMove];
            //delete element at its last position
            if (indexElementToMove !== -1) {
                QVoldOrderedList.splice(indexElementToMove, 1);
            }

            //insert element to new position
            QVoldOrderedList.splice(parseInt($scope.interface.QVtoMove.position) - 1, 0, elementToMove);

        };

        $scope.getQrUsedPerVisite = function() {
            // -- sélection du QuestionnaireTemplate
            var scope = $scope.$new();
            var qmList = $scope.eti.etudedefArray.questionsMeresList;

            scope.search_text = '';
            scope.foundQrvs = [];

            scope.callDisplayQrvInfo = function(Qr, Qrv) {

                //Analyse du QuestionnaiRe
                var qrNbQuestionsMeres = Qr.nombreQuestionsMeres ;
                var qrHasDate = !!Qr.questionmeredate_key ;
                var qrHasScore = !!Qr.questionmerescore_key ;
                var qrHasReasonNoResponse = !!Qr.questionmereraisonnonrempli_key ;

                //Analyse du QuestionnaireVisite
                var qrvNbQuestionsVisite = Qrv.questionsVisitesOrderedIds.length ;
                var qrvHasDate = !!Qrv.questionVisiteDate ;
                var qrvHasScore = !!Qrv.questionVisiteScore ;
                var qrvHasReasonNoResponse = !!Qrv.questionVisiteRaisonNonRempli ;

                return scope.displayQrvInfo(qrvNbQuestionsVisite, qrNbQuestionsMeres, qrvHasDate, qrHasDate, qrvHasScore, qrHasScore, qrvHasReasonNoResponse, qrHasReasonNoResponse) ;
            } ;

            scope.displayQrvInfo = function(nbQv, nbQr, dateQv, dateQr, scoreQv, scoreQr, reasonQv, reasonQr){

                var total = nbQr;
                var qvContent = '<span class="d-flex flex-column align-items-start ml-1">' ;

                //pour chaque date/score/raison non remplie :
                //elle n’entre pas en compte dans le total de son élément
                //et si dans le QR on l’affiche : rouge si pas e QRV, vert si bien présente
                if(dateQr){
                    total -= 1;
                    if(dateQv) {
                        nbQv -= 1;
                        qvContent += '<span class="text-valid">date</span>';
                    } else {
                        qvContent += '<span class="bg-dark text-warning text-bold">date</span>';
                    }
                }
                if(scoreQr){
                    total -= 1;
                    if(scoreQv) {
                        nbQv -= 1;
                        qvContent += '<span class="text-valid">score</span>';
                    } else {
                        qvContent += '<span class="bg-dark text-warning text-bold">score</span>';
                    }
                }
                if(reasonQr){
                    total -= 1;
                    if(reasonQv) {
                        nbQv -= 1;
                        qvContent += '<span class="text-valid">raison non rép.</span>';
                    } else {
                        qvContent += '<span class="bg-dark text-warning text-bold">raison non rép.</span>';
                    }
                }

                //affichage du nombre de questions calculées
                if(nbQv !== total) {
                    qvContent += '<span class="text-be-careful text-bold">QV '+nbQv+'/'+total+'</span>' ;
                } else {
                    qvContent += '<span>QV '+nbQv+'/'+total+'</span>' ;
                }

                qvContent += '</span>' ;
                return $sce.trustAsHtml(qvContent);
            };

            scope.searchQuestion = function(searched){
                scope.foundQrvs = [];
                if(searched==''){
                    return;
                }
                // search QRv keys corresponding to QV found. Search is done on QM (name, key and qm id)
                var foundQms = _.filter(qmList,function(qm){
                    // console.log(searched,qm.name.indexOf(searched));
                    return (qm.name).toLowerCase().indexOf(searched.toLowerCase()) !== -1 || (qm.key).toLowerCase().indexOf(searched.toLowerCase()) !== -1 || String(qm.id).indexOf(searched.toLowerCase()) !== -1;
                });
                // var qmKeys = _.pluck(foundQms,'key');
                var qmKeys = _.map(foundQms,function(qm){
                    return qm.key;
                });
                // console.log(foundQms,qmKeys);
                // loop on QV to get QRV ids
                _.each($scope.eti.etudedefArray.questionsVisitesList, function(qv){
                    if(qmKeys.indexOf(qv.question_mere_key) !== -1){
                        scope.foundQrvs.push(qv.questionnaire_visite_id);
                    }
                    //search on qv id
                    if(String(qv.id).indexOf(searched)!=-1){
                        scope.foundQrvs.push(qv.questionnaire_visite_id);
                    }
                });
                scope.foundQrvs = _.uniq(scope.foundQrvs);
                // console.log(scope.foundQrvs);
            }

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/qr-used-per-visite.html',
                    backdrop: 'static',
                    size: 'xl',
                    scope: scope
                });
        };

        //creation d'un questionnaire à partir de questionnaireTemplates
        $scope.addQuestionnaire = function() {

            // -- sélection du QuestionnaireTemplate
            var scope = $scope.$new();

            // -- on ne propose que ceux pas encore ajoutés à cette étude
            scope.questionnaireListInModal = _.filter(allQuestionnaireTemplate, function(questionnaireTemplateDef) {
                if (_.find($scope.eti.etudedefArray.questionnairesList, {key_cross_etude:questionnaireTemplateDef.key})) {
                    return false;
                }
                return true;
            });

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/modal-select-qr-template.html',
                    backdrop: 'static',
                    size: 'lg',
                    scope: scope
                });

            $scope.modalInstance.result.then(function(qrTemplateKey) {
                // -- si on a sélectionné un Questionnaire Template
                if (qrTemplateKey) {

                    // -- on l'ajoute à notre Etude par RECOPIE
                    var url = 'etude-def/builder-etude-def-add-qr-def-from-qr-template/etude-def/'+$rootScope.eti.etude_def.key+'/qr-template-key/'+qrTemplateKey;

                    $http.get(url).then(function() {

                        // -- puis on refresh
                        $scope.refreshEtudeDefConf().then(function() {
                            var visite = $scope.visite;
                            mbsEtiService.setCurrentEti(-1);
                            $scope.doMapDataEtiConfiguration();
                            mbsEtiService.setCurrentVisite(visite);
                        })
                    });
                }
            })

        };

        var refreshEtude = function() {
                let etudeDefKey = $rootScope.eti.etude_def.key;

                var promiseRefresh = $scope.refreshEtudeDefConf();

                $rootScope.participantTracker.addPromise(promiseRefresh);

                promiseRefresh.then(function() {
                    // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                    mbsParticipantService.init();
                    var promiseRefreshParticipant =  $http.get('etude-def/builder-etude-def-participant/' + etudeDefKey );

                    $rootScope.participantTracker.addPromise(promiseRefreshParticipant);

                    promiseRefreshParticipant.then(function (r) {
                        mbsParticipantService.initWithParticipant(r.data.participant);

                        var visite = $scope.visite;
                        mbsEtiService.setCurrentEti(-1);
                        $scope.doMapDataEtiConfiguration();
                        mbsEtiService.setCurrentVisite(visite);
                    });
                });
            };

        $scope.addQR = function() {

            var scope = $scope.$new();

            //pré-peuplage du nouveau QR
            scope.qr = {
                etude_def_key: $scope.etude_def_builder_configuration.eti.etude_def_key,
                questionmeredate_key: $scope.etude_def_builder_configuration.eti.etude_def_key+"_QM__DATE_",
                questionmereraisonnonrempli_key: $scope.etude_def_builder_configuration.eti.etude_def_key+"_QM__RAISON_NON_REMPLI_",
                key: $scope.etude_def_builder_configuration.eti.etude_def_key+"_"
            };

            /* L'énoncé complète automatiquement la key_cross_etude, la questionmeredate_key, la questionmereraisonnonrempli_key et la key */
            scope.completeQrFields = function(qr) {
                qr.key_cross_etude = 'QR__' + qr.name
                    .replace(/à/gi,"a")
                    .replace(/é|è|ê/gi,"e")
                    .replace(/ï/gi,"i")
                    .replace(/ô/gi,"o")
                    .replace(/ù|û/gi,"u")
                    .replace(/ /g, "_")
                    .replace(/[!?,-;'"()/]/g, "")
                    .toUpperCase() ;
                scope.completeQrKey(qr);
                scope.completeQrQmDateKey(qr);
                scope.completeQrQmRaisonNonRempliKey(qr);
            };

            scope.completeQrKey = function(qr) {
                qr.key = qr.etude_def_key+"_"+qr.key_cross_etude;
            };

            scope.completeQrQmDateKey = function(qr) {
                qr.questionmeredate_key = qr.etude_def_key+"_QM__DATE_"+qr.key_cross_etude.substr(4);
            };

            scope.completeQrQmRaisonNonRempliKey = function(qr) {
                qr.questionmereraisonnonrempli_key = qr.etude_def_key+"_QM__RAISON_NON_REMPLI_"+qr.key_cross_etude.substr(4);
            };

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/create-qr.html',
                    backdrop: 'static',
                    size: 'lg',
                    scope: scope
                });

            $scope.modalInstance.result.then(function(data) {
                var qr = data.questionnaire;
                var resource = 'questionnaire-def';
                qr.editOrSave = 'SAVE';

                console.log(qr);

                $http.post(resource, qr).then(function(response)
                {
                    // -- puis on refresh
                    refreshEtude();

                }).catch(function (e) {
                    console.log(e);
                })
            });
        };

        $scope.addQuestionnaireVisite = function(onglet) {
            // -- sélection du QuestionnaireTemplate
            var scope = $scope.$new();
            // -- on ne propose que ceux pas encore ajoutés à cette visite
            scope.questionnaireListInModal = _.filter($scope.eti.etudedefArray.questionnairesList, function(questionnaireDef) {
                if (_.find($scope.visite.getQuestionnairesVisites(), {questionnaire_key:questionnaireDef.key})) {
                    return false;
                }
                return true;
            });

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/modal-select-qr-template.html',
                    backdrop: 'static',
                    size: 'lg',
                    scope: scope
                });

            $scope.modalInstance.result.then(function(qrKey) {
                // -- si on a sélectionné un Questionnaire Template
                if (qrKey) {

                    var visiteKey   = $scope.visite.key;
                    var ongletId    = onglet.id;

                    // -- on l'ajoute à notre Etude par RECOPIE
                    var url = 'etude-def/builder-etude-def-add-qr-visite-from-qr-def/etude-def/'+$rootScope.eti.etude_def.key+'/visite-key/'+visiteKey+'/onglet-id/'+ongletId+'/qr-key/'+qrKey;



                    $http.get(url).then(function() {

                        // -- puis on refresh
                        refreshEtude();
                    });
                }
            })
        };

        $scope.addQvToQrv = function(questionnaireVisite) {
            $scope.selectedQuestionnaire = questionnaireVisite.getQuestionnaire();
            let listQmAvailable = $scope.selectedQuestionnaire.getQuestionsMeres();

            questionnaireVisite.questionsVisitesOrderedIds.forEach(function(index) {
                let qm_key = $scope.eti.etudedefArray.questionsVisitesList[index].question_mere_key;
                //on retire la qm déjà utilisée de la liste des qm disponibles
                let indexElementToDel = _.findIndex(listQmAvailable, {key: qm_key});
                if (indexElementToDel !== -1) {
                    listQmAvailable.splice(indexElementToDel, 1);
                }
            });

            var scope = $scope.$new();
            scope.qrv = questionnaireVisite;
            scope.selected_qm = {};
            scope.unusedQmList = listQmAvailable;
            scope.questionsList = $scope.eti.etudedefArray.questionsVisitesList;

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/add-qv-to-qrv.html',
                    backdrop: 'static',
                    size: 'lg',
                    scope: scope
                });

            $scope.modalInstance.result.then(function(data) {

                if(data) {
                    $http.post('etude-def/builder-etude-def-add-qv-to-qrv', data).then(function(response) {
                        // -- puis on refresh
                        // commented because refreshEtude() calls $scope.refreshEtudeDefConf()
                        // $scope.refreshEtudeDefConf().then(function() {
                            // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                            refreshEtude();
                        // });
                    });
                }
            });
        };

        $scope.createQmForQr = function(questionnaire) {
            // -- sélection du QuestionnaireTemplate
            var scope = $scope.$new();

            //pré-peuplage de la nouvelle QM
            scope.qm = {
                etude_def_key: $scope.etude_def_builder_configuration.eti.etude_def_key,
                questionnaire_key: questionnaire.key,
                key: $scope.etude_def_builder_configuration.eti.etude_def_key+"_",
                is_editable: 1
            };

            /* L'énoncé complète automatiquement la key_cross_etude et la key */
            scope.completeQmFields = function(qm) {
                qm.key_cross_etude = 'QM__' + qm.text
                                                .replace(/à/gi,"a")
                                                .replace(/é|è|ê/gi,"e")
                                                .replace(/ï/gi,"i")
                                                .replace(/ô/gi,"o")
                                                .replace(/ù|û/gi,"u")
                                                .replace(/ /g, "_")
                                                .replace(/[!?,-;'"()/]/g, "")
                                                .toUpperCase() ;
                scope.completeQmKey(qm);
            };

            scope.completeQmKey = function(qm) {
                qm.key = qm.etude_def_key+"_"+qm.key_cross_etude;
            };

            scope.dataTypeSelected = function(qm) {
                if(qm.data_type === $scope.constants.data_types['NAMES_TO_VALUES']['DATE']) {
                    qm.input_options = "{\"maxDate\": \"\",\"minDate\": \"\"}";
                } else if((qm.data_type === $scope.constants.data_types['NAMES_TO_VALUES']['INTEGER'] || qm.data_type === $scope.constants.data_types['NAMES_TO_VALUES']['NUMBER']) && qm.is_editable === 1) {
                    qm.input_options = "{\"unit\": \"\",\"placeholder\": \"\"}";
                } else {
                    qm.input_options = "";
                }
            };

            scope.inputTypeSelected = function(qm) {
                switch(qm.input_type) {
                    case $scope.constants.input_types['NAMES_TO_VALUES']['BOOLEAN'] :
                        qm.data_type = $scope.constants.data_types['NAMES_TO_VALUES']['BOOLEAN'] ;
                        qm.input_options = "";
                        break;
                    case $scope.constants.input_types['NAMES_TO_VALUES']['DATE'] :
                        qm.data_type = $scope.constants.data_types['NAMES_TO_VALUES']['DATE'] ;
                        qm.input_options = "{\"maxDate\": \"\",\"minDate\": \"\"}";
                        break;
                    case $scope.constants.input_types['NAMES_TO_VALUES']['RADIO_BY_IDX'] :
                        qm.data_type = $scope.constants.data_types['NAMES_TO_VALUES']['INTEGER'] ;
                        qm.input_options = "";
                        break;
                    case $scope.constants.input_types['NAMES_TO_VALUES']['RATE_SLIDER'] :
                        qm.data_type = $scope.constants.data_types['NAMES_TO_VALUES']['INTEGER'] ;
                        qm.input_options = "{\"min\": 0, \"max\": 4}";
                        break;
                    case $scope.constants.input_types['NAMES_TO_VALUES']['SLIDER_BY_IDX'] :
                        qm.data_type = $scope.constants.data_types['NAMES_TO_VALUES']['INTEGER'] ;
                        qm.input_options = "{\"legendMin\": \"\",\"legendMax\": \"\"}";
                        break;
                    case $scope.constants.input_types['NAMES_TO_VALUES']['MULTIPLE_CHECKBOX'] :
                        qm.data_type = $scope.constants.data_types['NAMES_TO_VALUES']['MULTIPLE_MIXED'] ;
                        qm.input_options = "";
                        break;
                    default:
                        qm.input_options = "";
                        break;
                }
            };

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/create-qm-for-qr.html',
                    backdrop: 'static',
                    size: 'lg',
                    scope: scope
                });

            $scope.modalInstance.result.then(function(data) {
                var qm = data.questionMere;
                var resource = 'question-mere-def';
                qm.editOrSave = 'SAVE';

                if(qm.is_editable !== 1) {
                    qm.input_type = 'text' ;
                }

                $http.post(resource, qm).then(function(response) {
                    // -- puis on refresh
                    refreshEtude();

                }).catch(function (e) {
                    console.log(e);
                })
            });
        };

        //modale pour ordonner les QRV d'un onglet
        $scope.orderQuestionnaireVisite = function(onglet) {
            var scope = $scope.$new();
            //console.log('onglet : ', onglet);
            scope.qrvListInModal = [];
            scope.onglet_id = onglet.id;
            //console.log('QRV liste : ', $scope.visite.getQuestionnairesVisitesForOnglet(onglet));

            $scope.visite.getQuestionnairesVisitesForOnglet(onglet).forEach(function(qnv) {
                //console.log(qnv);
                scope.qrvListInModal.push({
                   id: qnv.id,
                   name: qnv.displayName
                });
            });

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/order-qrv-list.html',
                    backdrop: 'static',
                    size: 'md',
                    scope: scope
                })
            ;

            $scope.modalInstance.result.then(function(data) {
                if(data) {
                    //préparation de la liste ordonnée d'id en indiquant explicitement son nouvel ordre
                    let orderedQRVList = {};
                    //console.log('data reçue de la modale', data);
                    let num_ordre = 1;
                    data.list.forEach(function(qrv) {
                        orderedQRVList[qrv.id] = num_ordre;
                        num_ordre++
                    });

                    let dataToSend = {
                        onglet_id     : data.onglet_id,
                        orderedQRVList: orderedQRVList
                    };

                    //console.log('data envoyée au serveur : ', dataToSend);
                    $http.post('etude-def/order-qrv-list', dataToSend).then(function(response) {
                        // -- puis on refresh
                        refreshEtude();
                    });
                }
            });
        };

        $scope.orderCalcQV = function(onglet) {

            var scope = $scope.$new();

            scope.qvListInModal = [];

            $scope.visite.questionsVisitesOrderedIds.forEach(function(qv_id) {

                //nom du QRV
                let id_qrv = $rootScope.eti['etudedefArray']['questionsVisitesList'][qv_id]['questionnaire_visite_id'];
                let indexQRV = _.findIndex($scope.visite.getQuestionnairesVisites(), {id: id_qrv});
                let qrv_name = $scope.visite.getQuestionnairesVisites()[indexQRV].name !== "" ? $scope.visite.getQuestionnairesVisites()[indexQRV].name : $scope.visite.getQuestionnairesVisites()[indexQRV].displayName;

                //Type de la QV (normal, score ou date)


                let qm_key = $rootScope.eti['etudedefArray']['questionsVisitesList'][qv_id]['question_mere_key'];
                let type ;

                if(!$rootScope.eti['etudedefArray']['questionsMeresList'][qm_key]['isEditable'] && $rootScope.eti['etudedefArray']['questionsMeresList'][qm_key]["key"].includes("_SCORE_")) {
                    type = 'score';
                } else if($rootScope.eti['etudedefArray']['questionsMeresList'][qm_key]['dataType'] === 'date' && $rootScope.eti['etudedefArray']['questionsMeresList'][qm_key]['name'] === "Date de remplissage du questionnaire") {
                    type = 'date';
                } else if($rootScope.eti['etudedefArray']['questionsMeresList'][qm_key]["key"].includes("RAISON_NON_REMPLI")) {
                    type = 'raison-non-rempli';
                } else {
                    type = 'normal';
                }

                scope.qvListInModal.push({
                    id: qv_id,
                    label: $rootScope.eti['etudedefArray']['questionsVisitesList'][qv_id]['question_mere_key'],
                    order: $rootScope.eti['etudedefArray']['questionsVisitesList'][qv_id]['order'],
                    type: type,
                    qrv_name: qrv_name
                });
            });
            $scope.interface.QVorderedList = scope.qvListInModal;

            scope.onglet_id = onglet.id;
            scope.visite = {
                key: $scope.visite.key,
                name: $scope.visite.name
            };

            //empty selected QV to move
            $scope.interface.QVtoMove = {};

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/order-qr-traitement-list.html',
                    backdrop: 'static',
                    size: 'xl',
                    scope: scope
                })
            ;

            $scope.modalInstance.result.then(function(data) {
                if(data) {
                    //préparation de la liste ordonnée d'id en indiquant explicitement son nouvel ordre
                    let orderedQVList = {};

                    let num_ordre = 1;
                    data.list.forEach(function(qv) {
                        orderedQVList[qv.id] = num_ordre;
                        num_ordre++
                    });

                    let dataToSend = {
                        visite_key     : data.visite_key,
                        orderedQVList: orderedQVList
                    };
                    //console.log('data envoyée au serveur : ', dataToSend);
                    $http.post('etude-def/order-qv-list', dataToSend).then(function(response) {
                        // -- puis on refresh
                        refreshEtude();
                    });
                }
            });
        };

        $scope.deleteQuestionnaireVisite = function(qrvObj) {
            let delQRV = confirm('ATTENTION, souhaitez-vous réellement supprimer le QuestionnaiReVisite de cet onglet, ainsi que tous les QuestionsVisites associées ?');
            let delAlsoQRandQM = false;
            if(delQRV) {
                delAlsoQRandQM = confirm('Souhaitez-vous aussi supprimer son QuestionnaiRe, toutes les QuestionMères qui y sont reliées donc leurs QuestionsVisite ?');
            }

            if (qrvObj && delQRV) {

                var etudeDefKey = $rootScope.eti.etude_def.key;

                // -- on l'ajoute à notre Etude par RECOPIE
                var urlDelQRV = 'etude-def/builder-etude-def-remove-qr-visite-from-onglet-def/etude-def/'+etudeDefKey+'/qrv-key/'+qrvObj.key;
                var urlDelQR = 'etude-def/builder-etude-def-remove-qr-from-onglet-def/etude-def/'+etudeDefKey+'/qr-key/'+qrvObj.questionnaire_key;

                $http.get(urlDelQRV).then(function() {
                    if(delAlsoQRandQM) {
                        $http.get(urlDelQR).then(function() {
                            // -- puis on refresh
                            $scope.refreshEtudeDefConf().then(function() {
                                // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                                refreshEtude();
                            });
                        });
                    } else {
                        // -- puis on refresh
                        $scope.refreshEtudeDefConf().then(function() {
                            // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                            refreshEtude();
                        });
                    }
                });
            }
        };

        $scope.moveQuestionnaireVisite = function(qrvObj) {

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/move-onglet.html',
                    backdrop: 'static',
                    // size: 'xl',
                    scope: $scope
                })
            ;

            var etudeDefKey = $rootScope.eti.etude_def.key;

            $scope.modalInstance.result.then(function(ongletId) {
                if (ongletId) {
                    if (ongletId == qrvObj.onglet_id) {
                        alert('Ce Questionnaire Visite est déjà dans cet onglet');
                    } else {
                        var url = 'etude-def/builder-etude-def-move-qrv-to-onglet/etude-def/'+etudeDefKey+'/qrv-key/'+qrvObj.key + '/o-id/' + ongletId;

                        $http.get(url).then(function() {
                            // -- puis on refresh
                            $scope.refreshEtudeDefConf().then(function() {
                                // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                                refreshEtude();
                            });
                        });
                    }
                }
            });
        };

        $scope.goToQuestionnaireVisite = function (qrvKey) {
            $window.open('#!/settings/questionnaire-visite-def?key=' + qrvKey, '_blank');
        };

        $scope.goToQuestionnaire = function (qrKey) {
            $window.open('#!/settings/questionnaire-def?key=' + qrKey, '_blank');
        };


        $scope.selectDetailQuestionnaire = function(questionnaire) {
            // var scope = $scope.$new();
            $scope.selectedQuestionnaire = questionnaire;
            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/detail-questionnaire.html',
                    backdrop: 'static',
                    // size: 'xl',
                    scope: $scope
                })
            ;
        };

        $scope.selectDetailQuestionnaireVisite = function(questionnaireVisite) {
            $scope.selectedQuestionnaireVisite = questionnaireVisite;
            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/detail-questionnaire-visite.html',
                    backdrop: 'static',
                    size: 'xl',
                    scope: $scope
                })
            ;
        };

        $scope.moveQuestionMereOfQr = function(questionVisite) {
            var questionMere = $scope.eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key];


            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/move-qr.html',
                    backdrop: 'static',
                    // size: 'xl',
                    scope: $scope
                })
            ;

            var etudeDefKey = $rootScope.eti.etude_def.key;

            $scope.modalInstance.result.then(function(qrKey) {
                if (qrKey) {
                    // -- si on sélectionnaire le QR auquel appartient déjà la QM
                    if (qrKey == _.find($scope.eti.etudedefArray.questionnairesVisitesList, {id: questionVisite.questionnaire_visite_id}).questionnaire_key) {
                        alert('Cette QuestionMere appartient déjà à ce Questionnaire');
                    } else {
                        var url = 'etude-def/builder-etude-def-move-question-mere-of-questionnaire/etude-def/'+etudeDefKey+'/qm-key/'+questionMere.key + '/qr-key/' + qrKey;

                        $http.get(url).then(function() {
                            // -- puis on refresh
                            $scope.refreshEtudeDefConf().then(function() {
                                // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                                refreshEtude();
                            });
                        });
                    }
                }
            });
        };

        $scope.deleteQuestionVisite = function(questionVisite) {

            var questionMere = $scope.eti.etudedefArray.questionsMeresList[questionVisite.question_mere_key];
            //console.log('deleteQuestionVisite', questionVisite, questionMere);

            var delQV = confirm('ATTENTION, souhaitez-vous réellement supprimer la QuestionVisite de ce QuestionnaireVisite?');
            var delAlsoQM = false;
            if(delQV) {
                delAlsoQM = confirm('Souhaitez-vous supprimer totalement la QuestionMere de son QuestionnaiRe, toutes les QuestionVisite qui y sont reliées seront supprimées?');
            }

            if (questionVisite && delQV) {

                var etudeDefKey = $rootScope.eti.etude_def.key;

                var url;
                if (delAlsoQM) {
                    url =  'etude-def/builder-etude-def-remove-question-mere-from-questionnaire/etude-def/'+etudeDefKey+'/qm-key/'+questionMere.key;
                } else {
                    url = 'etude-def/builder-etude-def-remove-question-visite-from-questionnaire-visite/etude-def/'+etudeDefKey+'/qv-id/'+questionVisite.id;
                }

                var promiseRemove = $http.get(url);

                $rootScope.participantTracker.addPromise(promiseRemove);

                promiseRemove.then(function() {
                    // -- puis on refresh
                    $scope.refreshEtudeDefConf().then(function() {
                        // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                        refreshEtude();
                    });
                });
            }

        };

        $scope.deleteElementQuestionMereDef = function(item)
        {
            var text = 'Supprimer cet élément de la Question Mère ?';
            if ($window.confirm(text))
            {
                $http.delete('element-question-mere-def/' + item.id, item)
                    .then(function(response) {
                        //find the element of QM in the list
                        let myQmId = response.data.question_mere_def_id ;
                        let myQM = _.find($scope.etude_def_builder_configuration.eti.etudedefArray.questionsMeresList, { id: myQmId });

                        let myQvId = myQM.relatedQuestionsVisitesIds[$rootScope.visite.key];
                        let myQv = $scope.etude_def_builder_configuration.eti.etudedefArray.questionsVisitesList[myQvId];

                        //remove deleted element from the list
                        let indexElmtToDelete = _.findIndex(myQv.localAttributes.dynamicDropDown, { id: item.id});
                        myQv.localAttributes.dynamicDropDown.splice(indexElmtToDelete, 1);
                        $scope.refreshEtudeDefConf().then(function() {
                             // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                             refreshEtude();
                        });
                    }).catch(function (e) {
                    console.log(e);
                })
            }
        };

        $scope.addElementQuestionMereDef = function(questionMere)
        {
            var scopeNew = $scope.$new();
            scopeNew.autoOpenModal = false;
            var settingsCtrlScope = scopeNew;

            // loading resource
            var resource = 'element-question-mere-def?'+ 'question_mere_def_id' +'='+questionMere.id;
            var promise = $http.get(resource).then(function(r){

                var resourceSetting = r.data;
                var allowedFields   = ['name','order','question_mere_def_id','key'];
                resourceSetting.form.elements = _.filter(resourceSetting.form.elements, function (element) {
                    if (allowedFields.indexOf(element.name) > -1) {
                        return true;
                    }
                    return false;
                });

                var ctrSetting = $controller('ctrlSettings', {
                    $scope: settingsCtrlScope,
                    // resolve: {
                    list: resourceSetting,
                    resource: 'element-question-mere-def',
                    mainFk: {question_mere_def_id: questionMere.id}
                });
                settingsCtrlScope.openEditModal().then(function() {
                    // -- puis on refresh
                    // commented because refreshEtude() calls $scope.refreshEtudeDefConf()
                    // $scope.refreshEtudeDefConf().then(function() {
                        // et on refresh le fake participant pour qu'il ait le bon nombre de champs
                        refreshEtude();
                    // });

                })
            });

        };


        //modale pour ordonner les QRV d'un onglet
        $scope.orderElementQuestionMere = function(questionVisite, questionMere) {
            var scope = $scope.$new();
            scope.question_mere_id = questionMere.id;

            scope.elementQuestionMereInModal = questionVisite.localAttributes.dynamicDropDown;

            $scope.modalInstance =
                $uibModal.open({
                    templateUrl: 'assets/templates/etude-def/modals/order-element-qm-list.html',
                    backdrop: 'static',
                    size: 'md',
                    scope: scope
                })
            ;


            $scope.modalInstance.result.then(function(data) {
                if(data) {
                    //préparation de la liste ordonnée d'id en indiquant explicitement son nouvel ordre
                    let orderedElementQMList = {};
                    //console.log('data reçue de la modale', data);
                    let num_ordre = 1;
                    data.list.forEach(function(qrv) {
                        orderedElementQMList[qrv.id] = num_ordre;
                        num_ordre++
                    });

                    let dataToSend = {
                        question_mere_id     : data.question_mere_id,
                        orderedElementQMList: orderedElementQMList
                    };

                    //console.log('data envoyée au serveur : ', dataToSend);
                    $http.post('etude-def/order-element-qm-list', dataToSend).then(function(response) {
                        // -- puis on refresh
                        refreshEtude();
                    });
                }
            });
        };


        $scope.refreshEtudeDefConf = function() {

            var etude_def_key = $scope.etude_def_builder_configuration.eti.etude_def.key;

            return $http.get('etude-def/builder-etude-def/'+etude_def_key)
                .then(function(resp){

                    console.log('eti configuration queried on server');
                    mbsEtiService.storeData(resp.data);

                    $scope.etude_def_builder_configuration = mbsEtiService.getConfigurationForEti(0);

                });

        };

        /**
         * *************************************************************************************************
         * ********************* DATA and ROUTE
         * *************************************************************************************************
         */

        $scope.doMapDataEtiConfiguration = function () {
            //// -- do it only when we change of ETI or has been updated
            if ((mbsEtiService.getCurrentEti().id !== $scope.etude_def_builder_configuration.eti.id) || (mbsEtiService.getCurrentEti().updated_at != $scope.etude_def_builder_configuration.eti.updated_at)) {
                mbsEtiService.initWithEti($scope.etude_def_builder_configuration.eti);
            }
            // -- si on a l'ETI en cache, mais qu'on passe par ce hook, alors il faut réinit les calculs dans les objets enrichis
            else if (mbsEtiService.getCurrentEti().id === $scope.etude_def_builder_configuration.eti.id) {
                mbsEtiService.reinitData();
            }


            // $scope.onglet                 = $rootScope.eti.etudedefArray.ongletsList[$rootScope.visite.ongletsOrderedIds[0]];
            // $scope.interface.ongletsCount = $rootScope.visite.ongletsOrderedIds.length;
        };

        /**
         * *************************************************************************************************
         * ********************* Initialization
         * *************************************************************************************************
         */

        /**
         * setup the controller
         */
        var initialize = function () {
            // -- setup data from resolver
            $scope.doMapDataEtiConfiguration();

            mbsParticipantService.statelessTransformParticipantHeader($scope.participant);

            mbsParticipantService.statelessTransformParticipantValues($scope.participant);
        };

        initialize();
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude-def/etudeDefIndex.js